/// <amd-module name="Artifacts/Root/helpers/UserHelpers" />

import { FeedOperationPermissions } from "Artifacts/Root/Constants";
import { ICommand } from "Artifacts/Root/protocols/types/ICommand";
import { IFeed } from "Artifacts/Root/types";
import { IVssPageContext } from "VSS/Platform/Context";
import { UserClaims, userHasClaim } from "VSS/Platform/UserClaims";

export function isUserAnonymousOrPublic(pageContext: IVssPageContext): boolean {
  const isAnonymousUser = userHasClaim(pageContext, UserClaims.Anonymous);
  const isPublicUser = userHasClaim(pageContext, UserClaims.Public);
  return (isAnonymousUser || isPublicUser) === true;
}

export function getIsUserMember(pageContext: IVssPageContext): boolean {
  return !isUserAnonymousOrPublic(pageContext);
}

/**
 * isUserPermittedToUseCommand encapsulates the logic to determine if the user
 * has sufficient feed permissions to access the given command
 * @param command a command with a permissionBitMask
 * @param feed a feed with the user permissionBitMask
 * @returns a boolean to dig
 */
export function isUserPermittedToUseCommand(command: ICommand, feed: IFeed): boolean {
  return (feed.permissionBitMask & command.permissionBitMask) !== command.permissionBitMask;
}

/**
 * isUserPermittedToUseOperation encapsulates the logic to determine if the user
 * has sufficient feed permission to perform specified feed operation
 * @param number a number representing the FeedOperationPermission to be checked
 * @param feed a feed with the user permissionBitMask
 * @returns a boolean indicating if a user is permitted to use operation
 */
export function isUserPermittedToUseOperation(permission: number, feed: IFeed): boolean {
  return (feed.permissionBitMask & permission) === permission;
}

export function isUserFeedAdmin(feed: IFeed): boolean {
  return isUserPermittedToUseOperation(FeedOperationPermissions.AdministerFeed, feed);
}

export function userCanAdministerFeeds(feed: IFeed): boolean {
  return feed.accountMetadata.userCanAdministerFeeds;
}

export function userCanCreateFeeds(feed: IFeed): boolean {
  return feed.accountMetadata.userCanCreateFeeds;
}